import { Pipe, PipeTransform } from '@angular/core';

import { VersionedEntity } from '../../viewmodels/versioned-entity';

@Pipe({
  name: 'nameVersion',
})
export class NameVersionPipe implements PipeTransform {

  transform(value: VersionedEntity, args?: any): string {
    if (value.version === 0) {
      return value.name;
    }
    return value.name + ' v' + value.version;
  }

}
